<template>
<div class='map_container'>
    <div id=cesiumContainer class='map_left'></div>
</div>
</template>

<script>
import { application, g_app } from '@/app/app'
export default {
    components: {},
    data() {
        return {
            wid: undefined
        }
    },
    mounted() {
        this.wid = this.$route.query.id
        g_app.destroy()
        this.createMap()
    },
    methods: {
        createMap() {
            g_app.create('cesiumContainer', {
                animation: false,
                baseLayerPicker: false,
                imageryProvider: false,
                geocoder: false,
                timeline: false,
                navigationHelpButton: false,
                sceneModePicker: false,
                homeButton: false,
                selectionIndicator: false,
                infoBox: false,
                selectionMode: false,
                shouldAnimate: true,
                showGroundAtmosphere: false,
                wid: this.wid
            })
        }
    },
    beforeDestroy() {

    },
    beforeCreate() {

    },
    watch: {
        $route(to, from) {
            this.wid = to.query.id
            g_app.destroy()
            this.createMap()
        }
    }
}
</script>

<style lang='scss' scoped>
.map_container {
    display: flex;
    .map_left{
        flex: 1;
        height: calc(100vh - 96px);
    }
}

</style>
